import React, { useEffect, useState } from "react";
import { getProducts, deleteProduct } from "./productService";
import { toast } from "react-toastify";
import { PencilSquare, Trash, Image } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";

function ProductList({ onEdit }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  const navigate = useNavigate(); // 👈 navigation hook

  const loadData = async () => {
    setLoading(true);
    try {
      const res = await getProducts();
      setProducts(res.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure?")) return;
    try {
      await deleteProduct(id);
      toast.success("Product Deleted");
      loadData();
    } catch (error) {
      toast.error("Delete failed");
    }
  };

   // 👇 Navigate to Image Manager
  const handleImageManage = (productId) => {
    navigate(`/admin/product-images/${productId}`);
  };

  const filtered = products.filter((item) =>
    item.productName.toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
  loadData();
}, []);

  if (loading) return <div>Loading...</div>;

  return (
    <div className="card p-4 shadow-sm rounded-3">
      
      <div className="row border-bottom border-1 pb-2">
        <div className="col-md-8"></div>
          <div className="col-md-4">
              <input
                type="text"
                className="form-control w-100"
                placeholder="Search..."
                onChange={(e) => setSearch(e.target.value)}
              />
        </div>
      </div>

    <table className="table table-hover">
      <thead>
        <tr>
          <th>Name</th>
          <th>Price</th>
          <th>MRP</th>
          <th>Variants</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {filtered.map((p) => (
          <tr key={p.productId}>
            <td>{p.productName}</td>
            <td>{p.price}</td>
            <td>{p.mrp}</td>
            <td>{p.variants?.length || 0}</td>
            <td>
              <button className="btn btn-sm btn-warning me-2" onClick={() => onEdit(p.productId)}><PencilSquare /></button>
                <button
                  className="btn btn-sm btn-info text-white me-2"
                  onClick={() => handleImageManage(p.productId)}
                  title="Manage Images"
                >
                  <Image />
                </button>
              <button className="btn btn-sm btn-danger" onClick={() => handleDelete(p.productId)}><Trash /></button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
   
  );
}

export default ProductList;